import React, { useEffect, useState } from "react";
import styles from "../../../assets/css/admin/layout.module.css";
import axios from "axios";
import SideBar from "../SideBar";
import { baseUrl } from "../../../baseUrl";
import {useAuth} from "../../../AuthContext"
import { useSidebar } from "../../../context/SidebarContext";
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { Link } from "react-router-dom";
import api from "../../../api";

const CreateExam = () => {
  const { logout, user } = useAuth();
  const { isSidebarOpen, toggleSidebar } = useSidebar();
  const [name, setName] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [timeLimit, setTimeLimit] = useState("");
  const [attempts, setAttempts] = useState("");
  const [className,setClassName]=useState('')
  const [course, setCourse] = useState('');
  const [courses, setCourses] = useState([]);
  const [physicsTopics, setPhysicsTopics] = useState("");
  const [chemistryTopics, setChemistryTopics] = useState("");
  const [biologyTopics, setBiologyTopics] = useState("");
  const today = new Date().toISOString().split("T")[0];
  const [processing,setProcessing]=useState(false)

  const [message, setMessage] = useState("");
  const formatTopics = (value) =>
    value
      .split(",")
      .map((topic) => topic.trim())
      .filter(Boolean);

  const topics = {
    Physics: formatTopics(physicsTopics),
    Chemistry: formatTopics(chemistryTopics),
    Biology: formatTopics(biologyTopics),
  };

  const data = { name, startDate, endDate, timeLimit, attempts,course,className, topics };
  const getCourses = () => {
    axios.get(`${baseUrl}/course/by-class?className=${className}`)
      .then(res => setCourses(res.data))
      .catch(err => console.log(err))
  }
  const handleCourse = (e) => {
    const selectedOption = e.target.selectedOptions[0];
    const selectedCourse = selectedOption ? JSON.parse(e.target.value) : null;
    setCourse(selectedCourse);  // Update selected course
  };
  useEffect(() => {
      const timer = setTimeout(() => {
        setMessage(false);
      }, 4000);
      return () => clearTimeout(timer);
    }, [message]);
  useEffect(() => {
    getCourses()
  }, [className])
  useEffect(()=>{
    axios.get(`${baseUrl}/course/all`)
    .then(res=>setCourses(res.data))
    .catch(err=>console.log(err))
  },[])
  const handleSubmit = (e) => {
    if(name===''||startDate===''||endDate===''||timeLimit===''||attempts===''||className===''||course===''){
      setMessage('Please enter all details')
    }else{
      setProcessing(true)
      api
        .post(`${baseUrl}/exam/create`, { data })
        .then((res) => {
          setMessage(res.data)
          setProcessing(false)
        })
        .catch((err) => 
        {
          if(err.response) setMessage(err.response.data.message)
          if(err.message==="Network Error") setMessage('Unable to reach Server, please try again')
          setProcessing(false)
        }
      );
    }

  };

  return (
    <div className={`${styles.layout} ${isSidebarOpen ? '' : `${styles.sidebarClosed}`}`}>
      <aside
        className={`${styles.sidebar} ${isSidebarOpen ? `${styles.open}` : `${styles.closed}`}`}
      >
        <SideBar />
      </aside>

      <main className={styles.mainContent}>
        <div style={{ height: '30px' }} className="position-relative">{isSidebarOpen ? <CloseIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar} /> : <MenuIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar} />}</div>
        <nav aria-label="breadcrumb" >
          <ol className="breadcrumb">
            <div className="d-flex flex-grow-1">
              <li className="breadcrumb-item">
                <Link to='/admin/dashboard' className="text-decoration-none">Dashboard</Link>
              </li>
              <li className="breadcrumb-item">
              <Link to='/admin/exams' className="text-decoration-none">All Exams</Link>
              </li>
              <li className="breadcrumb-item active">
                Create
              </li>
            </div>
            <li className="nav-item dropdown">
              <span
                className="nav-link dropdown-toggle"
                data-bs-toggle="dropdown"
                href=""
                role="button"
                aria-expanded="false"
              >
                Welcome, {user.name}
                <i className="ml-2 fa fa-angle-down"></i>
              </span>
              <ul className="dropdown-menu" style={{ minWidth: '150px' }}>
                <li>
                  <span className="dropdown-item" onClick={logout}>
                    Logout
                  </span>
                </li>
              </ul>
            </li>
          </ol>
        </nav>
        <div
          className={`container ${styles.container}`}>
          <div className="bg-white p-4">
            <h4>Create Exam</h4>
            <div className="row mb-3">
              <div className="col-lg-6">
                <label htmlFor="examName" className="form-label">
                  Exam Name
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="examName"
                  placeholder="Enter Name"
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-lg-6">
                <label htmlFor="startDate" className="form-label">
                  Start Date
                </label>
                <input
                  type="date"
                  className="form-control"
                  id="startDate"
                  placeholder=""
                  onChange={(e) => setStartDate(e.target.value)}
                  min={today}
                />
              </div>
              <div className="col-lg-6">
                <label htmlFor="endDate" className="form-label">
                  End Date
                </label>
                <input
                  type="date"
                  className="form-control"
                  id="endDate"
                  placeholder=""
                  onChange={(e) => setEndDate(e.target.value)}
                  min={today}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-lg-6">
                <label htmlFor="timeLimit" className="form-label">
                  Time Limit in minutes
                </label>
                <input
                  type="number"
                  className="form-control"
                  id="timeLimit"
                  placeholder=""
                  onChange={(e) => setTimeLimit(e.target.value)}
                />
              </div>
              <div className="col-lg-6">
                <label htmlFor="attempts" className="form-label">
                  Number of attempts
                </label>
                <input
                  type="number"
                  className="form-control"
                  id="attempts"
                  placeholder=""
                  onChange={(e) => setAttempts(e.target.value)}
                />
              </div>
            </div>
            <div className="row mt-3">
            <div className="col-lg-6">
                <label htmlFor="class" className="form-label">
                  Class
                </label>
                <select
                  className="form-select"
                  id="class"
                  value={className}
                  onChange={(e) => setClassName(e.target.value)}
                  required
                >
                  <option value="" hidden>Select Class</option>
                  <option>Class XI</option>
                  <option>Class XII</option>
                  <option>Class XII Passed</option>
                </select>
              </div>
              <div className="col-lg-4">
                <label htmlFor="course" className="form-label">
                  Course
                </label>
                {
                  courses.length < 1 ?
                    <p>No course available</p>
                    :
                    <select
                      onChange={handleCourse}
                      className="form-select"
                      id="course"
                      aria-label="Select Course"
                      value={course ? JSON.stringify(course) : 'c'}  // Control value of select
                    >
                      <option hidden>Select Course</option>
                      {
                        courses.map((c, i) =>
                          <option key={i} value={JSON.stringify(c)}>
                            {c.title}
                          </option>
                        )
                      }
                    </select>

                }
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-lg-4">
                <label htmlFor="physicsTopics" className="form-label">
                  Physics Topics
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="physicsTopics"
                  placeholder="Topic 1, Topic 2"
                  value={physicsTopics}
                  onChange={(e) => setPhysicsTopics(e.target.value)}
                />
              </div>
              <div className="col-lg-4">
                <label htmlFor="chemistryTopics" className="form-label">
                  Chemistry Topics
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="chemistryTopics"
                  placeholder="Topic 1, Topic 2"
                  value={chemistryTopics}
                  onChange={(e) => setChemistryTopics(e.target.value)}
                />
              </div>
              <div className="col-lg-4">
                <label htmlFor="biologyTopics" className="form-label">
                  Biology Topics
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="biologyTopics"
                  placeholder="Topic 1, Topic 2"
                  value={biologyTopics}
                  onChange={(e) => setBiologyTopics(e.target.value)}
                />
              </div>
            </div>
            {message && (
              <div
                className="alert alert-warning alert-dismissible fade show mt-3"
                role="alert"
              >
                {message}
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="alert"
                  aria-label="Close"
                  onClick={() => setMessage(false)}
                ></button>
              </div>
            )}
            <button disabled={processing} onClick={handleSubmit} className="btn btn-primary mt-4">
              {processing?'Loading...':'Create'}
            </button>
          </div>
        </div>
      </main>
    </div>
  );
};

export default CreateExam;
